import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/success.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "p-d-flex p-jc-center" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "user header",
    src: _imports_0
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_Message, {
        severity: "success",
        closable: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Bạn đã đăng ký khám bệnh ở bệnh viện Y Học Cổ Truyền thành công, thời gian khám là " + _toDisplayString($setup.date) + ". ", 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Message, {
        severity: "info",
        closable: false
      }, {
        default: _withCtx(() => [
          _createVNode("div", {
            innerHTML: $setup.appConfig.address
          }, null, 8, ["innerHTML"])
        ]),
        _: 1
      }),
      _createVNode(_component_Message, {
        severity: "warn",
        closable: false
      }, {
        default: _withCtx(() => [
          _createVNode("div", {
            innerHTML: $setup.appConfig.notice
          }, null, 8, ["innerHTML"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}